import React, {FC} from 'react';
import styled from "styled-components";
import {PlaneStatus, usePlaneStatusName} from "../../../../../utils/constans/statuses/planeStatuses";

const StatusBadge = styled.div<{status: PlaneStatus, isAdmin: boolean}>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 2px 13px;
  border-radius: 23px;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  width: fit-content;
  
  ${props => {
    if (!props.isAdmin) {
      // Стили для оператора
      switch (props.status) {
        case PlaneStatus.UPLOAD_DOCUMENTS:
          return `
            background-color: #E7C4C4;
            color: #000;
          `;
        case PlaneStatus.PENDING_APPROVAL:
          return `
            background-color: #CDDDE6;
            color: #000;
          `;
        case PlaneStatus.APPROVED:
          return `
            background-color: #D6E6CD;
            color: #000;
          `;
        default:
          return `
            background-color: #F5F5F5;
            color: #666;
          `;
      }
    } else {
      // Стили для админа (как было)
      switch (props.status) {
        case PlaneStatus.UPLOAD_DOCUMENTS:
          return `
            background-color: #E7C4C4;
            color: #000;
          `;
        case PlaneStatus.PENDING_APPROVAL:
          return `
            background-color: #F9D99B;
            color: #000;
          `;
        case PlaneStatus.APPROVED:
          return `
            background-color: #D6E6CD;
            color: #000;
          `;
        default:
          return `
            background-color: #F5F5F5;
            color: #666;
          `;
      }
    }
  }}
`;

interface IPlaneStatusBadge {
  status: PlaneStatus;
  isAdmin?: boolean;
}

export const PlaneStatusBadge: FC<IPlaneStatusBadge> = ({status, isAdmin = true}) => {
  const statusName = usePlaneStatusName(status, isAdmin);
  
  return (
    <StatusBadge status={status} isAdmin={isAdmin}>
      <span>{statusName}</span>
    </StatusBadge>
  );
};

